import { render, staticRenderFns } from "./PersonResta.vue?vue&type=template&id=76d44790&"
import script from "./PersonResta.vue?vue&type=script&lang=js&"
export * from "./PersonResta.vue?vue&type=script&lang=js&"
import style0 from "./PersonResta.vue?vue&type=style&index=0&id=76d44790&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports